import { render } from "./StudyProtocolMng.vue?vue&type=template&id=665894ce&scoped=true"
import script from "./StudyProtocolMng.js?vue&type=script&lang=js"
export * from "./StudyProtocolMng.js?vue&type=script&lang=js"

import "./StudyProtocolMng.vue?vue&type=style&index=0&id=665894ce&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-665894ce"]])

export default __exports__